import Big from 'big.js'

/* TODO:
 * Cambiar y dejar value para valores por ej new Big(123)
 * o true y false. Y dejar lexema para el texto leido.
 * esto sirve para el linter, para que avance el stream
 * segun el texto leido y no el valor convertido.
 */

let BaseConfig = {
    // Constants
    CONS_INT: {
        code: 1001,
        regex: '[0-9]+',
        name: 'constante entera',
        lexema: function (text) {
            return new Big(parseInt(text, 10))
        }
    },
    CONS_STRING: {
        code: 1002,
        regex: '"[^"]*"',
        name: 'constante string',
        lexema: function (text) {
            return text.replace(/^"+|"+$/g, '')
        }
    },
    CONS_BOOL: {
        code: 1003,
        keywords: ['Verdadero', 'Falso'],
        name: 'constante lógica',
        lexema: function (text) {
            if (text.toLowerCase() === 'verdadero') {
                return true
            }
            return false
        }
    },
    CONS_FLOAT: {
        code: 1004,
        regex: '[0-9]+\\.[0-9]+',
        name: 'constante real',
        lexema: function (text) {
            return new Big(parseFloat(text, 10))
        }
    },
    CONS_CHAR: {
        code: 1005,
        regex: '\\\'(\\s|\\S|\\\'\')\\\'',
        name: 'constante caracter',
        lexema: function (text) {
            var char = text.replace(/^'+|'+$/g, '')
            return new Big(char.charCodeAt(0))
        }
    },

    // Operators
    ASSIGN: {
        code: 2001,
        regex: '(<-)',
        name: 'operador de asignación',
        lexema: function (text) { return text }
    },
    MUL: {
        code: 2002,
        regex: '[\\*]',
        name: 'operador de multiplicación "*"',
        lexema: function (text) { return text }
    },
    DIV: {
        code: 2003,
        regex: '[/]',
        name: 'operador de división "/"',
        lexema: function (text) { return text }
    },
    SUB: {
        code: 2004,
        regex: '[-]',
        name: 'operador de resta "-"',
        lexema: function (text) { return text }
    },
    SUM: {
        code: 2005,
        regex: '[\\+]',
        name: 'operador de suma "+"',
        lexema: function (text) { return text }
    },
    AND: {
        code: 2006,
        regex: '[&]',
        name: 'operador de conjunción "&"',
        lexema: function (text) { return text }
    },
    OR: {
        code: 2007,
        regex: '[\\|]',
        name: 'operador de disyunción "|"',
        lexema: function (text) { return text }
    },
    NOT: {
        code: 2008,
        regex: '[\\~]',
        name: 'operador de negación "~"',
        lexema: function (text) { return text }
    },
    POW: {
        code: 2009,
        regex: '[\\^]',
        name: 'operador de potencia "^"',
        lexema: function (text) { return text }
    },
    MOD: {
        code: 2010,
        regex: '(%)',
        name: 'operador de módulo "%"',
        lexema: function (text) { return text }
    },

    // Punctuation
    COMMA: {
        code: 3001,
        regex: '[,]',
        name: 'coma',
        lexema: function (text) { return text }
    },
    SEMICOLON: {
        code: 3002,
        regex: '[;]',
        name: 'punto y coma',
        lexema: function (text) { return text }
    },
    OPEN_PAR: {
        code: 3003,
        regex: '[(]',
        name: 'apertura de paréntesis',
        lexema: function (text) { return text }
    },
    CLOSE_PAR: {
        code: 3004,
        regex: '[)]',
        name: 'cierre de paréntesis',
        lexema: function (text) { return text }
    },
    COLON: {
        code: 3005,
        regex: '[:]',
        name: 'dos puntos',
        lexema: function (text) { return text }
    },
    INDEX_SEL_OPEN: {
        code: 3006,
        regex: '[\\[]',
        name: 'apertura de corchetes',
        lexema: function (text) { return text }
    },
    INDEX_SEL_CLOSE: {
        code: 3007,
        regex: '[\\]]',
        name: 'cierre de corchetes',
        lexema: function (text) { return text }
    },

    // Keywords
    K_PROCESS: {
        code: 4001,
        keywords: ['Algoritmo'],
        lexema: function (text) { return text }
    },
    K_END_PROCESS: {
        code: 4002,
        keywords: ['FinAlgoritmo'],
        lexema: function (text) { return text }
    },
    K_DEFINE: {
        code: 4003,
        keywords: ['Definir'],
        lexema: function (text) { return text }
    },
    K_AS: {
        code: 4004,
        keywords: ['Como'],
        lexema: function (text) { return text }
    },
    K_FOR: {
        code: 4006,
        keywords: ['Para'],
        lexema: function (text) { return text }
    },
    K_TO: {
        code: 4007,
        keywords: ['Hasta'],
        lexema: function (text) { return text }
    },
    K_DO: {
        code: 4008,
        keywords: ['Hacer'],
        lexema: function (text) { return text }
    },
    K_END_FOR: {
        code: 4009,
        keywords: ['FinPara'],
        lexema: function (text) { return text }
    },
    K_IF: {
        code: 4010,
        keywords: ['Si'],
        lexema: function (text) { return text }
    },
    K_THEN: {
        code: 4011,
        keywords: ['Entonces'],
        lexema: function (text) { return text }
    },
    K_ELSE: {
        code: 4012,
        keywords: ['SiNo'],
        lexema: function (text) { return text }
    },
    K_END_IF: {
        code: 4013,
        keywords: ['FinSi'],
        lexema: function (text) { return text }
    },
    K_ABS: {
        code: 4014,
        keywords: ['ABS'],
        lexema: function (text) { return text }
    },
    K_SQRT: {
        code: 4015,
        keywords: ['RC'],
        lexema: function (text) { return text }
    },
    K_WHILE: {
        code: 4016,
        keywords: ['Mientras'],
        lexema: function (text) { return text }
    },
    K_END_WHILE: {
        code: 4017,
        keywords: ['FinMientras'],
        lexema: function (text) { return text }
    },
    K_REPEAT: {
        code: 4018,
        keywords: ['Repetir'],
        lexema: function (text) { return text }
    },
    K_UNTIL: {
        code: 4019,
        keywords: ['Hasta Que'],
        lexema: function (text) { return text }
    },
    K_STEP: {
        code: 4020,
        keywords: ['Con Paso'],
        lexema: function (text) { return text }
    },
    K_DIMENSION: {
        code: 4021,
        keywords: ['Dimension'],
        lexema: function (text) { return text }
    },
    K_SUB_PROCESS: {
        code: 4022,
        keywords: ['Procedimiento'],
        lexema: function (text) { return text }
    },
    K_END_SUB_PROCESS: {
        code: 4023,
        keywords: ['FinProcedimiento'],
        lexema: function (text) { return text }
    },
    K_BY: {
        code: 4024,
        keywords: ['Por'],
        lexema: function (text) { return text }
    },
    K_VALUE: {
        code: 4025,
        keywords: ['Valor'],
        lexema: function (text) { return text }
    },
    K_REFERENCE: {
        code: 4026,
        keywords: ['Referencia'],
        lexema: function (text) { return text }
    },
    K_FUNCTION: {
        code: 4027,
        keywords: ['Funcion'],
        lexema: function (text) { return text }
    },
    K_END_FUNCTION: {
        code: 4028,
        keywords: ['FinFuncion'],
        lexema: function (text) { return text }
    },
    K_RETURN: {
        code: 4029,
        keywords: ['Retorna'],
        lexema: function (text) { return text }
    },
    K_WITHOUT_JUMP: {
        code: 4030,
        keywords: ['Sin Saltar'],
        lexema: function (text) { return text }
    },
    K_WAIT: {
        code: 4031,
        keywords: ['Esperar'],
        lexema: function (text) { return text }
    },
    K_SELECT: {
        code: 4032,
        keywords: ['Segun'],
        lexema: function (text) { return text }
    },
    K_OTHERWISE: {
        code: 4033,
        keywords: ['De Otro Modo'],
        lexema: function (text) { return text }
    },
    K_END_SELECT: {
        code: 4034,
        keywords: ['FinSegun'],
        lexema: function (text) { return text }
    },
    K_READ: {
        code: 4035,
        keywords: ['Leer'],
        lexema: function (text) { return text }
    },
    K_WRITE: {
        code: 4036,
        keywords: ['Escribir'],
        lexema: function (text) { return text }
    },
    K_CLEAR_SCREEN: {
        code: 4037,
        keywords: ['Borrar Pantalla'],
        lexema: function (text) { return text }
    },
    K_KEY: {
        code: 4038,
        keywords: ['Tecla'],
        lexema: function (text) { return text }
    },
    K_MOD: {
        code: 4039,
        keywords: ['MOD'],
        lexema: function (text) { return text }
    },

    K_INT: {
        code: 5001,
        keywords: ['Entero'],
        lexema: function (text) { return text }
    },
    K_BOOL: {
        code: 5002,
        keywords: ['Logico'],
        lexema: function (text) { return text }
    },
    K_FLOAT: {
        code: 5003,
        keywords: ['Real'],
        lexema: function (text) { return text }
    },
    K_CHAR: {
        code: 5004,
        keywords: ['Caracter'],
        lexema: function (text) { return text }
    },

    // Comparators
    EQ: {
        code: 6001,
        regex: '=',
        lexema: function (text) { return text }
    },
    NEQ: {
        code: 6002,
        regex: '<>',
        lexema: function (text) { return text }
    },
    LT: {
        code: 6003,
        regex: '<',
        lexema: function (text) { return text }
    },
    GT: {
        code: 6004,
        regex: '>',
        lexema: function (text) { return text }
    },
    GTE: {
        code: 6005,
        regex: '>=',
        lexema: function (text) { return text }
    },
    LTE: {
        code: 6006,
        regex: '<=',
        lexema: function (text) { return text }
    },

    // Identifier
    IDENT: {
        code: 9001,
        regex: '[a-zA-Z_][a-zA-Z0-9_]*',
        name: 'identificador',
        lexema: function (text) { return text }
    }
}

export default BaseConfig



// WEBPACK FOOTER //
// ./src/Core/Language/BaseConfig.js